import { useTrans } from '@/shared/hooks/useTranslation';
import { Button } from '@/view/shared/Button';
import { Modal } from '@/view/shared/Modal';
import type { NewVersionViewState } from '@/viewmodel/shared/versionCheck';
import { Rocket } from 'lucide-react';

export function NewVersionModal({ isOpen, dismiss, reload }: Readonly<NewVersionViewState>) {
  const { t } = useTrans();

  return (
    <Modal
      isOpen={isOpen}
      setIsOpen={dismiss}
      title={t('newVersion.title')}
      icon={<Rocket className="h-5 w-5 text-primary" aria-hidden />}
      size="sm"
    >
      <div className="flex flex-col gap-4">
        <p className="text-sm text-foreground/80">{t('newVersion.body')}</p>
        <div className="flex justify-end gap-2">
          <Button variant="ghost" onClick={dismiss}>
            {t('newVersion.later')}
          </Button>
          <Button onClick={reload}>{t('newVersion.reload')}</Button>
        </div>
      </div>
    </Modal>
  );
}
